export default __webpack_public_path__ + "static/media/cancelConfirmIcon.be3ec330.png";